<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="600"
      size="small"
      :expand-config="{ reserve: true }"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:specifyslot="{row}">
        <el-tag size="mini" type="info">
          {{row.v_isSpecify}}
        </el-tag>
      </template>
      <template v-slot:expandContent="{ row }">
        <!--设置插槽内的表格宽度-->
        <div class="m-2">
          <child-table
            :disabled="disabled"
            :mrpPackagePlanDetailCode="row.mrpPackagePlanDetailCode"
          />
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import ChildTable from './components/index.vue'
import tableColumns from './table-columns'

export default {
  mixins: [TableAutoHeight],
  components: {ChildTable },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true
      },
      tableColumns:tableColumns(this)
    }
  },
  methods: {
    
  }
}
</script>
